import React, { Component } from 'react'

import { connect } from 'react-redux'
import * as api from '../../api/api'
import * as actions from '../../actions'
import OpportunityForm from './OpportunityForm'
import StatusMessage from '../../util/StatusMessage'
import SerializeForm from 'form-serialize'

class CreateOpportunity extends Component {
	state = {
		errorMsg: '',
		data: {}
	}

	handleFormSubmit = (formData) => {
    return
    //e.preventDefault()
    
    api.saveOpportunity(this.props.user.accessToken,formData)
    .then((result) => {
    	if(result.status === 'success'){
        this.setState({ errorMsg: '' })
        this.props.history.push('/portal/app/admin/opportunities')
      }
      else{
        this.setState({ errorMsg: 'Error in creating Opportunity' })
      }
    })
    .catch((err) => {
    // console.log(`error:${err.stack}`)
      this.setState({ errorMsg: err.stack })
    })
  }

	render() {
		return (<div>
      <StatusMessage error_msg = {this.state.errorMsg}/>
			<OpportunityForm onFormSubmit={this.handleFormSubmit} />
      
      </div>
		)
	}

}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateOpportunity);


// WEBPACK FOOTER //
// ./src/views/opportunities/CreateOpportunity.jsx